import requestv2 from "~/utils/http-v2";

const workingDayApi = {
	gets : async (params) => {
		const url = 'v2/working-day';
		return await requestv2.get(url, {params});
	},
	attendance : async (params) => {
		const url = 'v2/working-day/attendance';
		return await requestv2.post(url, params);
	},
	updateByUser : async (params) => {
		const url = `v2/working-day/${params.id}`;
		return await requestv2.patch(url, params);
	},
};

export default workingDayApi;